import { memo } from 'react'

import { useMatchRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import {
  mediaPlatformSettingsOverviewRoute,
  mediaPlatformSettingsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'
import {
  mediaPlatformSettingsLegalPrivacyOverviewRoute,
  mediaPlatformSettingsLegalRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Legal'
import {
  mediaPlatformSettingsPermissionsRoute,
  mediaPlatformSettingsPermissionsUsersOverviewRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Permissions'
import { mediaPlatformSettingsRegionsOverviewRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Regions'
import { mediaPlatformSettingsSetupsOverviewRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Setups'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages', 'entity'])
  const matchRoute = useMatchRoute()

  return (
    <Content
      HeaderSlot={<Header disabled title={t('entity:publishing.settings')} />}
      SubNavigation={
        <Tabs>
          <NavigationTabLink from={mediaPlatformSettingsRoute.fullPath} to={mediaPlatformSettingsOverviewRoute.to}>
            {t('pages:MediaOTT.mediaPlatform.Spaces.general')}
          </NavigationTabLink>
          <NavigationTabLink
            selected={
              !!matchRoute({
                to: mediaPlatformSettingsPermissionsRoute.to,
                fuzzy: true,
              })
            }
            from={mediaPlatformSettingsRoute.fullPath}
            to={mediaPlatformSettingsPermissionsUsersOverviewRoute.to}
          >
            {t('pages:MediaOTT.mediaPlatform.Spaces.permissions')}
          </NavigationTabLink>
          <NavigationTabLink
            from={mediaPlatformSettingsRoute.fullPath}
            to={mediaPlatformSettingsRegionsOverviewRoute.to}
          >
            {t('pages:MediaOTT.mediaPlatform.Spaces.regions')}
          </NavigationTabLink>
          <NavigationTabLink
            from={mediaPlatformSettingsRoute.fullPath}
            to={mediaPlatformSettingsSetupsOverviewRoute.to}
          >
            {t('pages:MediaOTT.mediaPlatform.Spaces.setups')}
          </NavigationTabLink>
          <NavigationTabLink
            selected={
              !!matchRoute({
                to: mediaPlatformSettingsLegalRoute.to,
                fuzzy: true,
              })
            }
            from={mediaPlatformSettingsRoute.fullPath}
            to={mediaPlatformSettingsLegalPrivacyOverviewRoute.to}
          >
            {t('pages:MediaOTT.mediaPlatform.Spaces.legal')}
          </NavigationTabLink>
        </Tabs>
      }
    />
  )
}

export const Structure = memo(StructureRaw)
